import { render, staticRenderFns } from "./comp_SmartPopupCenter.vue?vue&type=template&id=564bd2bc&scoped=true"
import script from "./comp_SmartPopupCenter.vue?vue&type=script&lang=js"
export * from "./comp_SmartPopupCenter.vue?vue&type=script&lang=js"
import style0 from "./comp_SmartPopupCenter.vue?vue&type=style&index=0&id=564bd2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564bd2bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VIcon,VRow})
